import React from 'react';
import styles from 'styles/components/TrialExpiredModal.module.css';
import Modal from '@ax2/common/components/Modal';
import { ActionButton } from '@ax2/common/components/ActionButton';

export interface TrialExpiredModalProps {
  onClose: () => void;
}

const TrialExpiredModal: React.FC<TrialExpiredModalProps> = props => {
  const redirectToProdPurchase = () => {
    window.location.href = 'https://ax.healthstrategies.com/shop';
  };
  const redirectToProdContactUs = () => {
    window.location.href = 'https://ax.healthstrategies.com/support';
  };
  return (
    <div className={styles.trialExpiredModalOuterWrapper}>
      <Modal onClose={props.onClose}>
        <div className={styles.modalContent}>
          <div>Your trial account has expired.</div>
          <div className={styles.purchaseSection}>
            <div className={styles.purchaseButtonContainer}>
              <ActionButton
                type="primaryAlt"
                text="Click here to purchase"
                onClick={redirectToProdPurchase}
              />
            </div>
            <div className={styles.footnote}>
              *You will be asked to create a new login prior to purchase.
            </div>
          </div>

          <div className={styles.contactSection}>
            <div>For any other questions...</div>
            <div className={styles.contactButtonContainer}>
              <ActionButton
                text="Contact us"
                onClick={redirectToProdContactUs}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TrialExpiredModal;
